import { FnAccordianPanelComponent } from './fn-accordian-pannel/fn-accordian-panel.component';
import {
	Component,
	ViewEncapsulation,
	Input,
	HostBinding,
} from '@angular/core';

@Component({
	selector: 'fn-accordian',
	template: `
		<ng-content></ng-content>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class FnAccordianComponent {
	@HostBinding('attr.multiFnPanelOpen')
	@Input()
	openMultiplePanel: boolean;
	@HostBinding('class') class = 'fn-accordian';
	private openedFnPanel: FnAccordianPanelComponent = null;

	closeOtherPanels(fnPannel: FnAccordianPanelComponent): void {
		if (this.openMultiplePanel) {
			return;
		} else if (this.openedFnPanel === null) {
			this.openedFnPanel = fnPannel;
			return;
		} else if (this.openedFnPanel !== fnPannel) {
			this.openedFnPanel.isOpen = false;
			this.openedFnPanel = fnPannel;
		}
	}
}
